import { toArray } from "@suse-o11y/to-array";

export function reorder<T>(list: ArrayLike<T>, sourceIndex: number, destinationIndex: number): Array<T> {
	const result = toArray(list);

	if (sourceIndex === destinationIndex || result.length < 2 || sourceIndex < 0 || sourceIndex >= result.length) {
		return result;
	}

	const removed = result.splice(sourceIndex, 1);

	result.splice(destinationIndex, 0, ...removed);

	return result;
}
